export default "__VITE_ASSET__BPQFlIYH__"